'use strict';

// Export a few requires we might need
// from devtools and iframes.

function requireProxy(module) {
  switch (module) {
  case 'react':
    return require('react/addons');
  case 'ExternalActionCreators':
    return require('./actions/ExternalActionCreators');
  case 'AppDispatcher':
    return require('./AppDispatcher');
  default:
    console.warn('Module "' + module + '" not defined for external require in requireProxy');
  }
}

module.exports = requireProxy;


/** WEBPACK FOOTER **
 ** ./requireProxy.js
 **/